var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWcollection(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "bi:collection",
    clipPath: "url(#clip0_1431_13564)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M3.75 5.25C3.55109 5.25 3.36032 5.17098 3.21967 5.03033C3.07902 4.88968 3 4.69891 3 4.5C3 4.30109 3.07902 4.11032 3.21967 3.96967C3.36032 3.82902 3.55109 3.75 3.75 3.75H20.25C20.4489 3.75 20.6397 3.82902 20.7803 3.96967C20.921 4.11032 21 4.30109 21 4.5C21 4.69891 20.921 4.88968 20.7803 5.03033C20.6397 5.17098 20.4489 5.25 20.25 5.25H3.75ZM6.75 2.25C6.55109 2.25 6.36032 2.17098 6.21967 2.03033C6.07902 1.88968 6 1.69891 6 1.5C6 1.30109 6.07902 1.11032 6.21967 0.96967C6.36032 0.829018 6.55109 0.75 6.75 0.75H17.25C17.4489 0.75 17.6397 0.829018 17.7803 0.96967C17.921 1.11032 18 1.30109 18 1.5C18 1.69891 17.921 1.88968 17.7803 2.03033C17.6397 2.17098 17.4489 2.25 17.25 2.25H6.75ZM0 19.5C0 20.0967 0.237053 20.669 0.65901 21.091C1.08097 21.5129 1.65326 21.75 2.25 21.75H21.75C22.3467 21.75 22.919 21.5129 23.341 21.091C23.7629 20.669 24 20.0967 24 19.5V9C24 8.40326 23.7629 7.83097 23.341 7.40901C22.919 6.98705 22.3467 6.75 21.75 6.75H2.25C1.65326 6.75 1.08097 6.98705 0.65901 7.40901C0.237053 7.83097 0 8.40326 0 9L0 19.5ZM2.25 20.25C2.05109 20.25 1.86032 20.171 1.71967 20.0303C1.57902 19.8897 1.5 19.6989 1.5 19.5V9C1.5 8.80109 1.57902 8.61032 1.71967 8.46967C1.86032 8.32902 2.05109 8.25 2.25 8.25H21.75C21.9489 8.25 22.1397 8.32902 22.2803 8.46967C22.421 8.61032 22.5 8.80109 22.5 9V19.5C22.5 19.6989 22.421 19.8897 22.2803 20.0303C22.1397 20.171 21.9489 20.25 21.75 20.25H2.25Z",
    fill: "#FEFEFE"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1431_13564"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWcollection);
export default __webpack_public_path__ + "static/media/wcollection.cdb6e84b939edc2705c6d6bdf778cd75.svg";
export { ForwardRef as ReactComponent };